export enum ErrorsMap {
  'invalid_grant' = 'ERR001' ,
  'BAD_REQUEST' = 'BAD_REQUEST' ,
  'PS001' = 'PS001', //Request type not supported
  'PS002' = 'PS002', //Phone number is not verified (R1)
  'PS003' = 'PS003', //Error verifying password
  'PS004' = 'PS004', //Username is in use by other person registered
  'PS005' = 'PS005', //Email is in use by other person registered
  'PS006' = 'PS006', //T&C was not accepted by user
  'PS007' = 'PS007', //Error selecting categories (R4),
  'CB001' = 'CB001',
  'CB002' = 'CB002',
  'CB003' = 'CB003',
  'CB004' = 'CB004',
  'CB005' = 'CB005',
  'CB006' = 'CB006',
  'CB007' = 'CB007',
  'CB008' = 'CB008',
  'HW001' = 'HW001',
}